"use client";

import { Slider } from "@/components/ui/slider";

interface ThumbSliderProps {
    checked?: boolean;
    value: number;
    onValueChange: (value: number) => void;
}

export default function ThumbSlider({ checked, value, onValueChange }: ThumbSliderProps) {
    const handleSliderChange = (newValue: number[]) => {
        if (newValue.length > 0) {
            onValueChange(newValue[0]);
        }
    };

    return (
        <>
            {checked && (
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between gap-2 ">
                        <output className="text-3xl tabular-nums">{value}%</output>
                    </div>
                    <div className="relative flex flex-col gap-2 w-full">
                        <Slider
                            value={[value]}
                            onValueChange={handleSliderChange}
                            aria-label="Slider with output"
                            className="relative w-full h-3"
                            data-slot="slider"
                        />

                        <span
                            className="text-accent flex w-full items-center justify-between gap-0 text-xs font-medium px-2"
                            aria-hidden="true"
                        >
                            {[0, 25, 50, 75, 100].map((persent) => (
                                <span
                                    key={persent}
                                    className="flex items-center flex-col cursor-pointer w-0 gap-0 justify-center"
                                    onClick={() => onValueChange(persent)}
                                >
                                    <span
                                        className={`size-3 rounded-full absolute top-0 ${
                                            persent <= value ? "bg-primary" : "bg-muted"
                                        }`}
                                    ></span>
                                    {persent}%
                                </span>
                            ))}
                        </span>
                    </div>
                </div>
            )}
        </>
    );
}
